import BodyText from "./BodyText";
import Box from "./Box";
import React from "react";

function GreenIcon({ icon, label }) {
  return (
    <Box display="flex" alignItems="center">
      <Box
        height={52}
        width={52}
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        {icon}
      </Box>
      <BodyText ml="8px" color="green">
        {label}
      </BodyText>
    </Box>
  );
}

export default GreenIcon;
